import React, { FC } from 'react'
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'

const DataGridWithFilters: FC<React.PropsWithChildren<{
  autoScroll?: boolean,
  filterWidth?: number,
  filters?: React.ReactNode,
  filterPosition?: 'left' | 'right',
  datagrid?: React.ReactNode,
  pagination?: React.ReactNode,
}>> = ({
  autoScroll = false,
  filterWidth = 300,
  filters,
  filterPosition = 'right',
  datagrid,
  pagination,
}) => {

  const filterElem = filters ? (
    <Box
      className="filters"
      sx={{
        flexGrow: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        width: `${filterWidth}px`,
        maxWidth: `${filterWidth}px`,
        minWidth: `${filterWidth}px`,
        height: '100%',
      }}
    >
      { filters }
    </Box>
  ) : null

  return (
    <Container
      disableGutters
      maxWidth="xl"
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'row',
        px: 1,
        pt: 1,
      }}
    >
      {
        filterPosition == 'left' && filterElem
      }
      <Box
        className="data"
        sx={{
          flexGrow: 1,
          height: '100%',
          flexBasis: `calc(100% - ${filterWidth}px)`,
          display: 'flex',
          flexDirection: 'column',
          pr: 1,
          mr: 1,
        }}
      >
        <Box
          className="grid"
          sx={{
            display: 'flex',
            ...(autoScroll
              ? {
                  height: '1px',
                  flexGrow: 1,
                  overflowY: 'auto',
                  mb: 1,
                }
              : {
                  flexGrow: 1,
                  mb: 1,
                })
          }}
        >
          { datagrid }
        </Box>
        {
          pagination && (
            <Box
              className="pagination"
              sx={{
                flexGrow: 0,
                mt: 1,
                mb: 1,
              }}
            >
              { pagination }
            </Box>
          )
        }
      </Box>
      {
        filterPosition == 'right' && filterElem
      }
    </Container>
  )
}

export default DataGridWithFilters